function playNativeIOSSound(kind) {
  try {
    const bridge = window?.webkit?.messageHandlers?.nativeBridge;
    if (!bridge?.postMessage) return false;
    bridge.postMessage({ action: "playAlertSound", kind });
    return true;
  } catch {
    return false;
  }
}

export function playPing() {
  if (playNativeIOSSound("alert")) return;
  const base = import.meta.env.BASE_URL || "/";
  const url = `${base}sounds/alert.mp3`;
  const audio = window.__trekkinPingAudio || new Audio(url);

  audio.volume = 0.5;
  audio.currentTime = 0;
  window.__trekkinPingAudio = audio;
  audio.play().catch(() => {});
}

// Keep chat feedback distinct from safety/off-trail alerts. The short ping is
// intentionally used only for messages; alert.mp3 remains the warning sound.
export function playChatMessage() {
  if (playNativeIOSSound("chat")) return;
  const base = import.meta.env.BASE_URL || "/";
  const url = `${base}sounds/ping.mp3`;
  const audio = window.__trekkinChatAudio || new Audio(url);

  audio.volume = 0.55;
  audio.currentTime = 0;
  window.__trekkinChatAudio = audio;
  audio.play().catch(() => {});
}
